var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-content',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('accessory-type-form',{ref:"form",on:{"o3-submit":function($event){return _vm.onSubmit($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }